// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const FortiOsIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#DA291C"
      d="M23.25 10.44v3.98h-6.22v-3.98zm-14.1 9.64h6.2V16.1h-6.2zm14.1-12.02a3.33 3.33 0 0 0-3.34-3.34h-2.85V8.7h6.19zM9.15 4.72V8.7h6.2V4.72zm-7.9 5.72v3.98h6.2v-3.98zm15.78 9.64h2.86a3.33 3.33 0 0 0 3.33-3.34v-.64h-6.2zM1.25 16.74a3.33 3.33 0 0 0 3.34 3.34h2.85V16.1H1.25zm0-8.68v.64h6.2V4.72H4.58a3.33 3.33 0 0 0-3.34 3.34"
    />
  </svg>,
  "FortiOs",
);
export default FortiOsIcon;
